exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".root-default-layout[data-v-171e5d00]{width:100%;background-color:#fff;margin:0 auto;padding-top:88px}.theme--dark.application{background:transparent}@media (max-width:769px){.root-default-layout[data-v-171e5d00]{padding-top:52px}}", ""]);

// exports
